import customerApi from '../../components/apis/customerApi';
import customerArrayBufferApi from '../../components/apis/customerArrayBufferApi';

export function getActiveTickets(params) {
  return customerApi.get('/api/customer/active-tickets', { params }).then((res) => res.data);
}

export function getTicketsHistory(params) {
  return customerApi.get('/api/customer/tickets-history', { params }).then((res) => res.data);
}

export function getRefundedTickets(params) {
  return customerApi.get('/api/customer/refunded-tickets', { params }).then((res) => res.data);
}

export function getTicketsByStatementId(id) {
  return customerApi.get(`/api/tickets/statement/${id}`).then((res) => res.data);
}

export function getTicketAdditionalServices(params) {
  return customerApi.get('/api/tickets/additional-services', { params }).then((res) => res.data);
}

export function addTicketAdditionalServices(values) {
  return customerApi.post('/api/tickets/additional-services', values).then((res) => res.data);
}

export function refundTicket(values) {
  return customerApi.post('/api/tickets/refund', values).then((res) => res.data);
}

export function calculateTicketRefund(values) {
  return customerApi.post('/api/tickets/calculate-refund', values).then((res) => res.data);
}

export function getStatementTicketsPDF(id, guid) {
  return customerArrayBufferApi.get(`/api/tickets/${id}/${guid}/pdf`).then((res) => res.data);
}

export function getStatementTicketsPDFBase64(id, guid) {
  return customerApi.get(`/api/tickets/${id}/${guid}/pdf/base64`).then((res) => res.data);
}

export function getTicketsPDF(id) {
  return customerArrayBufferApi.get(`/api/tickets/${id}/pdf`).then((res) => res.data);
}

export function getTicketPaymentStatus(id) {
  return customerApi.get(`/api/tickets/payment-status/${id}`).then((res) => res.data);
}

export function getTicketPassService(id) {
  return customerApi.get(`/api/tickets/${id}/pass-kit`).then((res) => res.data);
}
